import { AbstractControl, ValidationErrors } from '@angular/forms';

export function customTechnicalFactorValidator(control: AbstractControl): ValidationErrors | null {
  const val = control.value;

  if (val != null && val > 100) {
    return {
      numberNotAllowed: true,
    };
  }
  return null;
}
